import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    alert: {
      maxWidth: 800,
      margin: '0 auto',
    },
    button: {
      marginTop: 16,
      color: palette.white,
    },
    buttonGreen: { background: palette.navAdminActions },
    buttonGray: { background: palette.navSuperAdminActions },
    buttonBlue: { background: palette.navOperatorActions },
    buttonYellow: { background: palette.navCompanyContextActions },
  });
